module.exports = __webpack_public_path__ + "img/a2.b68ad46a.png";